import { useState, useEffect, useRef, React } from 'react'
import Logo from '../../constants/logo';
const { tableau } = window;

const BlogPage = () => {
    const [url] = useState(
        "https://public.tableau.com/views/LondonBikes_16972087409320/Dashboard1?:language=es-ES&:display_count=n&:origin=viz_share_link"
      );

    const ref = useRef(null);
    
    const initViz = () => {
        new tableau.Viz(ref.current, url);
      };
    
    useEffect(initViz, []);
      
  return (
    <div className='app' style={{backgroundColor:'#f5f5f5'}}>
        <nav className='app__navbar'>
        <Logo/>
        </nav>
    <div className='app__container'>
        <div className='app__wrapper app__flex'>  
            <div style={setVizStyle} ref={ref} />
        </div>
    </div>

    </div>
  )
}

const setVizStyle = {
    width: "100%",
    height: "100%",
  };

export default BlogPage